// src/pages/Login.jsx
import React, { useState, useContext } from 'react';
import {
  Form,
  Button,
  Card,
  Alert,
  InputGroup,
} from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

export default function LoginPage() {
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const [creds, setCreds] = useState({ username: '', password: '' });
  const [error, setError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await login(creds);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || 'Erreur de connexion');
    }
  };

  return (
    <section className="d-flex vh-100 align-items-center justify-content-center bg-light">
      <Card className="shadow-lg p-5" style={{ maxWidth: '400px', width: '100%' }}>
        <div className="text-center mb-4">
          <h1 className="brand text-primary">CRYSTAL</h1>
          <p className="text-muted small">Multi Services</p>
        </div>

        {error && <Alert variant="danger">{error}</Alert>}

        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="email">
            <Form.Label>Nom d'utilisateur</Form.Label>
            <Form.Control
              type="text"
              size="lg"
              placeholder="username"
              value={creds.username}
              onChange={(e) => setCreds({ ...creds, username: e.target.value })}
              required
            />
          </Form.Group>

          <Form.Group className="mb-4 position-relative" controlId="pass">
            <Form.Label>Mot de passe</Form.Label>
            <InputGroup>
              <Form.Control
                type={showPassword ? 'text' : 'password'}
                size="lg"
                placeholder="••••••"
                value={creds.password}
                onChange={(e) => setCreds({ ...creds, password: e.target.value })}
                required
              />
              <Button
                variant="link"
                className="position-absolute top-50 end-0 translate-middle-y me-3"
                onClick={() => setShowPassword(!showPassword)}
              >
                <i className={`bi bi-eye${showPassword ? '-slash' : ''}-fill`} />
              </Button>
            </InputGroup>
          </Form.Group>

          <Button variant="primary" size="lg" className="w-100" type="submit">
            Se connecter
          </Button>
        </Form>
      </Card>
    </section>
  );
}